import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form-new';

import { TextInput, Button } from 'components';
import { MIN_TEXT_INPUT_LENGTH } from 'global-constants';

export interface FormData {
    code: string;
}

export const EnterCodeForm = (props: { handleSubmitForm: (value: FormData) => void }) => {
    const { handleSubmitForm } = props;
    const { t, i18n } = useTranslation(['user-test', 'validation']);
    const { register, handleSubmit, formState, trigger } = useForm<FormData>();
    const { isSubmitting, isSubmitted, errors } = formState;

    useEffect(() => {
        if (isSubmitted) {
            trigger();
        }
    }, [trigger, i18n.language, isSubmitted]);

    return (
        <form
            onSubmit={handleSubmit(handleSubmitForm)}
            className="d-flex align-items-center justify-content-space-between"
            autoComplete="off"
        >
            <TextInput
                id="code"
                reg={register('code', {
                    required: {
                        value: true,
                        message: t('validation:required-field'),
                    },
                    minLength: {
                        value: MIN_TEXT_INPUT_LENGTH,
                        message: t('validation:min-length', {
                            minLength: MIN_TEXT_INPUT_LENGTH,
                        }),
                    },
                })}
                errorMessage={errors.code?.message as string}
            />
            <Button type="submit" buttonClass="primary" isDisabled={isSubmitting}>
                {t('enter-button')}
            </Button>
        </form>
    );
};
